import React from 'react';
import styles from '../../Card.scss.js';

/** @deprecated Use LegacyCard or AlphaCard instead. */
function Subsection({
  children
}) {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.warn('Deprecation: <Card /> is deprecated. This component will be removed in a future major version of Polaris. Use <LegacyCard /> or <AlphaCard /> instead.');
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.Subsection
  }, children);
}

export { Subsection };
